module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/NB_Flip Chip TDK设备.c178080a.png";